import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { WaitingListCreateInput } from '@libs/types/src/services/input-type/waiting-list-create.input';
import { WaitingListUpdateInput } from '@libs/types/src/services/input-type/waiting-list-update.input';
import { WaitingListGridObject, WaitingListObject } from '@libs/types/src/services/object-type/waiting-list.object';

@Injectable({ providedIn: 'root' })
export class WaitingListGqlService extends GqlServiceV2 {

    public getWaitingListItems(input: GridInput, fragment: string) {
        return this.query<WaitingListGridObject>(
            `
                query($input: GridInput!) {
                    waitingList {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createWaitingListItem(
        input: WaitingListCreateInput,
        fragment: string,
    ) {
        return this.mutate<WaitingListObject>(
            `
                mutation($input: WaitingListCreateInput!) {
                    waitingList {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    updateWaitingListItem(
        input: WaitingListUpdateInput,
        fragment: string,
    ) {
        return this.mutate<WaitingListObject>(
            `
                mutation($input: WaitingListUpdateInput!) {
                    waitingList {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteWaitingListItem(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    waitingList {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
